// Helpers for sending users to the login page and bringing them back.

// Areas that require a session. Losing the session here means redirecting to
// login; on public pages we just drop the session and let the visitor stay.
const PROTECTED_PREFIXES = ["/admin/dashboard", "/student"];

export const isProtectedPath = (pathname = window.location.pathname) =>
  PROTECTED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

// Only allow same-site relative paths as a post-login destination, so a
// crafted ?next= can't bounce the user to another domain.
export const safeNextPath = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  if (raw.startsWith("/sign-in")) return null;
  return raw;
};

// reason: "expired" when an existing session ended, omitted for a plain
// "please sign in" redirect.
export const buildLoginUrl = (next, reason) => {
  const params = new URLSearchParams();
  const safe = safeNextPath(next);
  if (safe) params.set("next", safe);
  if (reason) params.set("reason", reason);
  const query = params.toString();
  return query ? `/sign-in?${query}` : "/sign-in";
};

export const currentPath = () =>
  `${window.location.pathname}${window.location.search}`;
